class CustomDropdown {
  constructor(select) {
    this.select = select;
    this.wrapper = document.createElement('div');
    this.customSelect = document.createElement('div');
    this.optionsList = document.createElement('ul');
    this.isProcessing = false;
    
    this.init();
  }

  init() {
    // tekrar init koruması
    if (this.select?.dataset?.enhanced === 'true') return;
    this.select.dataset.enhanced = 'true';

  // Seçili değeri kontrol et (placeholder seçili ise onu göster, otomatik değer atama yok)
  let selectedOption = this.select.options[this.select.selectedIndex];
    
    // Ana select elementini gizle
    this.select.style.display = 'none';
    
    // Wrapper oluştur
    this.wrapper.className = 'custom-dropdown-wrapper';
    this.select.parentNode.insertBefore(this.wrapper, this.select);
    this.wrapper.appendChild(this.select);
    
    // Custom select butonu oluştur
    this.customSelect.className = 'custom-dropdown-button';
    // Placeholder seçiliyse kullanıcı seçim yapana kadar placeholder'ı göster
    this.setButtonContent(selectedOption);
    this.wrapper.appendChild(this.customSelect);
    
    // Seçenekler listesi oluştur
    this.optionsList.className = 'custom-dropdown-options';
    this.wrapper.appendChild(this.optionsList);
    
    // Seçenekleri oluştur (merkezileştirilmiş)
    this.buildOptionsList();
    
    // Event listeners ekle
    this.customSelect.addEventListener('click', (e) => {
      e.stopPropagation();
      this.toggleOptions();
    });
    
    document.addEventListener('click', (e) => {
      if (!this.wrapper.contains(e.target)) {
        this.closeAllDropdowns();
      }
    });

    // Variant değişikliğini dinle
    this.select.addEventListener('change', () => {
      this.updateSelectedOption();
      this.updateDisabledUI();
    });

    // Seçenek metinleri/metafield değerleri güncellendiğinde listeyi tazele
    this.select.addEventListener('dropdown:options-updated', () => {
      this.refreshOptionsList();
      this.updateSelectedOption();
    });

    // İlk render sonrası seçimi senkronize et
    this.updateSelectedOption();
    this.updateDisabledUI();
  // İlk yüklemede var olan data-metafield-value değerlerini UI'a işle
  this.refreshOptionsList();

    // disabled attribute değişimlerini izleyip UI güncelle
    this.mutationObserver = new MutationObserver(mutations => {
      let shouldRefresh = false;
      let shouldUpdateDisabled = false;
      
      for (const m of mutations) {
        if (m.type === 'attributes' && m.attributeName === 'disabled') {
          shouldUpdateDisabled = true;
        } else if (m.type === 'attributes' && m.attributeName === 'data-metafield-value') {
          shouldRefresh = true;
        }
      }
      
      // Debounce: aynı frame'de birden fazla güncellemeyi birleştir
      if (shouldRefresh) {
        if (this._refreshTimeout) clearTimeout(this._refreshTimeout);
        this._refreshTimeout = setTimeout(() => {
          this.refreshOptionsList();
        }, 10);
      }
      
      if (shouldUpdateDisabled) {
        this.updateDisabledUI();
      }
    });
    this.mutationObserver.observe(this.select, { attributes: true, subtree: true, attributeFilter: ['disabled', 'data-metafield-value'] });
  }

  shouldRenderOption(option, index) {
    const isDisabled = option.disabled;
    if ((index === 0 && isDisabled) || (isDisabled && !option.selected)) return false;
    return true;
  }

  buildOptionsList() {
    this.optionsList.innerHTML = '';
    Array.from(this.select.options).forEach((option, index) => {
      if (!this.shouldRenderOption(option, index)) return;

      const li = document.createElement('li');
      li.className = 'custom-dropdown-option';

      let { mainText, unitPriceText } = this.parseOptionTexts(option);

      const displayText = document.createElement('span');
      displayText.className = 'option-text';
      displayText.textContent = mainText;
      li.appendChild(displayText);

      // Adet dropdown'unda eksikse varyantlardan türet (sadece o adetin anahtarı varsa)
      if (!unitPriceText) {
        const derived = this.computeUnitPriceFromVariant(this.select, option);
        if (derived) {
          unitPriceText = derived;
          option.dataset.metafieldValue = derived;
        }
      }

      // Seçeneklerde varsa birim fiyat/mesaj etiketini göster
      if (unitPriceText) {
        const priceInfo = document.createElement('span');
        priceInfo.className = 'option-unit-price';
        priceInfo.textContent = unitPriceText;
        li.appendChild(priceInfo);
      }

      li.dataset.value = option.value;

      if (option.selected && !option.disabled) li.classList.add('selected');
      if (option.disabled) {
        li.classList.add('soldout');
        li.classList.add('disabled');
        li.setAttribute('aria-disabled', 'true');
      }

      li.addEventListener('click', () => this.handleOptionClick(li));
      this.optionsList.appendChild(li);
    });
  }

  parseOptionTexts(option) {
    const fullText = option?.text?.trim() || option?.value || '';
    let mainText = fullText;
    let unitPriceText = null;

    // '(Birim Fiyatı ...)' formatını yakala
    const unitMatch = fullText.match(/\(\s*Birim\s*Fiyatı\s*[^\)]*\)\s*$/i);
    if (unitMatch) {
      unitPriceText = unitMatch[0].replace(/[()]/g, '').trim();
      mainText = fullText.replace(unitMatch[0], '').trim();
    } else if (option?.dataset && option.dataset.metafieldValue) {
      unitPriceText = option.dataset.metafieldValue;
    }

    return { mainText, unitPriceText };
  }

  setButtonContent(option) {
    if (!option) return;
    let { mainText, unitPriceText } = this.parseOptionTexts(option);
    
    // Eğer unitPriceText yoksa, metafield'dan kontrol et
    if (!unitPriceText && option.dataset && option.dataset.metafieldValue) {
      unitPriceText = option.dataset.metafieldValue;
    }
    
    // Eğer hala yoksa ve adet select'iyse, computeUnitPriceFromVariant'dan dene
    if (!unitPriceText) {
      const computed = this.computeUnitPriceFromVariant(this.select, option);
      if (computed) {
        unitPriceText = computed;
        option.dataset.metafieldValue = computed; // Cache'le
      }
    }
    
    this.customSelect.innerHTML = '';
    const left = document.createElement('span');
    left.className = 'option-text';
    left.textContent = mainText || 'Seçiniz';
    this.customSelect.appendChild(left);

    if (unitPriceText) {
      const right = document.createElement('span');
      right.className = 'option-unit-price';
      right.textContent = unitPriceText;
      this.customSelect.appendChild(right);
    }
  }

  updateSelectedOption() {
    const selectedOption = this.select.options[this.select.selectedIndex];
    if (selectedOption) {
      this.setButtonContent(selectedOption);
      
      // Seçili class'ı güncelle
      const options = this.optionsList.querySelectorAll('.custom-dropdown-option');
      options.forEach(opt => {
        if (opt.dataset.value === selectedOption.value) {
          opt.classList.add('selected');
        } else {
          opt.classList.remove('selected');
        }
      });
    }
  }
  
  toggleOptions() {
    if (this.select.disabled) return;
    const isOpen = this.optionsList.classList.contains('open');
    this.closeAllDropdowns();
    
    if (!isOpen) {
      this.optionsList.classList.add('open');
      this.customSelect.classList.add('active');
    }
  }

  updateDisabledUI() {
    const disabled = !!this.select.disabled;
    if (disabled) {
      this.customSelect.classList.add('disabled');
      this.customSelect.setAttribute('aria-disabled', 'true');
      this.optionsList.classList.remove('open');
    } else {
      this.customSelect.classList.remove('disabled');
      this.customSelect.removeAttribute('aria-disabled');
    }
  }
  
  closeAllDropdowns() {
    document.querySelectorAll('.custom-dropdown-options').forEach(list => {
      list.classList.remove('open');
    });
    document.querySelectorAll('.custom-dropdown-button').forEach(button => {
      button.classList.remove('active');
    });
  }
  
  handleOptionClick(option) {
    const value = option.dataset.value;
    const relatedOption = Array.from(this.select.options).find(o => o.value === value);
    if (relatedOption && relatedOption.disabled) {
      // Fiyat kuralı nedeniyle disable ise tıklamayı işlemesin
      this.closeAllDropdowns();
      return;
    }
    // Debounce için kontrol
    if (this.isProcessing) return;
    this.isProcessing = true;
    
    // Select değerini güncelle.
    this.select.value = option.dataset.value;
    
    // Button content'i güncelle
    const selectedOption = this.select.options[this.select.selectedIndex];
    if (selectedOption) {
      this.setButtonContent(selectedOption);
    }
    
    // Change event'i tetikle
    const event = new Event('change', { bubbles: true });
    this.select.dispatchEvent(event);
    
    // Dropdown'ı kapat
    this.closeAllDropdowns();
    
    // Processing flag'i temizle
    setTimeout(() => {
      this.isProcessing = false;
    }, 100);
  }

  refreshOptionsList() {
    // Listeyi baştan oluştur; sonradan aktifleşen seçenekler görünsün
    this.buildOptionsList();
  }

  computeUnitPriceFromVariant(selectEl, optionEl) {
    try {
      const wrapper = selectEl.closest('.product-form__input');
      const optionIndex = parseInt(wrapper?.dataset?.optionIndex || wrapper?.getAttribute('data-option-index') || '0', 10);

      const group = selectEl.closest('variant-selects') || document.querySelector('variant-selects');
      if (!group) return null;

      const propsScript = group.querySelector('script[data-variant-properties]') || document.querySelector('script[data-variant-properties]');
      if (!propsScript) return null;
      
      const variantProps = JSON.parse(propsScript.textContent || '{}');

      const variantsScript = group.querySelector('[type="application/json"]');
      if (!variantsScript) return null;
      const variants = JSON.parse(variantsScript.textContent || '[]');

      const allWrappers = Array.from(group.querySelectorAll('.product-form__input'))
        .sort((a, b) => {
          const aIndex = parseInt(a.dataset.optionIndex || '0', 10);
          const bIndex = parseInt(b.dataset.optionIndex || '0', 10);
          return aIndex - bIndex;
        });

      const current = allWrappers.map(wrapper => {
        const select = wrapper.querySelector('select');
        return select ? (select.value || '') : '';
      });

      const qtyWrapper = allWrappers.find(wrapper => wrapper.dataset.optionRole === 'quantity');
      const qtyIndex = qtyWrapper
        ? parseInt(qtyWrapper.dataset.optionIndex || '0', 10)
        : (allWrappers.length === 3 ? 1 : 0);

      // Seçimlere göre en iyi eşleşen varyant(lar)ı bul
      let candidates = variants.filter(v => {
        if (!v.options) return false;
        if (v.options[optionIndex] !== optionEl.value) return false;
        for (let i = 0; i < v.options.length; i++) {
          if (i === optionIndex) continue;
          const sel = current[i];
          if (sel && v.options[i] !== sel) return false;
        }
        return true;
      });

      if (!candidates.length) {
        // En azından değişen option değerini tutan ilk varyantı al
        candidates = variants.filter(v => v.options && v.options[optionIndex] === optionEl.value);
      }
      if (!candidates.length) return null;
      const match = candidates[0];

      const map = variantProps[match.id];
      if (!map) {
        return null;
      }
      
      // Adet anahtarını belirle
      let adetKey = '';
      if (qtyIndex === optionIndex) {
        adetKey = optionEl.value;
      } else {
        adetKey = current[qtyIndex] || '';
      }
      // Fallback yok: sadece doğru adet anahtarı kullanılmalı
      if (!adetKey) return null;
      const result = map[adetKey] || null;
      return result;
    } catch (e) {
      return null;
    }
  }
}

// Sadece data-custom-dropdown="true" olan select'leri custom dropdown'a çevir
document.addEventListener('DOMContentLoaded', () => {
  const selects = document.querySelectorAll('.select__select[data-custom-dropdown="true"]');
  selects.forEach(select => new CustomDropdown(select));
});
